@if (userDeviceInfo === 'pc') {
  <div class="button-top {{ userDeviceInfo }}" (click)="scrollToTop()" [ngClass]="{ 'show-scrollTop': windowScrolled }">
    <button></button>
    <span [style.display]="userDeviceInfo === 'pc' ? 'inline' : 'none'">TOP</span>
  </div>
}

@if (userDeviceInfo === 'mobile') {
  <div>
    <div class="arrow-up-wrap" (click)="scrollToTop()" [ngClass]="{ 'show-scrollTop': windowScrolled }">
      <svg-icon class="arrow-up-fab-button" src="/assets/images/arrow-up-outline.svg" alt="" srcset="" />
    </div>
    <div
      style="transform: rotate(180deg)"
      class="arrow-down-wrap"
      (click)="scrollToBottom()"
      [ngClass]="{ 'show-scrollTop': windowScrolled }"
    >
      <svg-icon class="arrow-up-fab-button" src="/assets/images/arrow-up-outline.svg" alt="" srcset="" />
    </div>
  </div>
}
